export class InComplianceReportRequest {
    Offset: number;
    Limit: number;
    OrderBy: string;
    Ascending: boolean;
    SearchBy: string;
    ItemPacketId: string;
    VolunteerAreaIds: string[];
    GetAllResults: boolean;
}